var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"card-shadow border-radius-xl"},[(_vm.$route.name !== 'Login')?_c('base-btn',{on:{"click":_vm.goLogin}},[_vm._v("Login")]):_vm._e(),(_vm.$route.name !== 'About')?_c('base-btn',{on:{"click":_vm.goAbout}},[_vm._v("About")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }